import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SearchService } from '../../_services/search.service';
import { SelectSearchData } from './select-search.data';

@Component({
    selector: 'app-select-search',
    templateUrl: './select-search.component.html',
    styleUrls: ['./select-search.component.scss']
})
export class SelectSearchComponent {

    @Input('elements')
    get elements() {
        return this.inputs;
    }
    set elements(els) {

        this.inputs = els;
        this.allInputs = els;
        this.initValue();
    }

    @Input('selModel')
    get selModel() {
        return this.current.id;

    }
    set selModel(el) {
        this.current.id = el;
        this.initValue();
    }
    @Input() hasCancelButton = false;
    @Output() selModelChange: EventEmitter<number> = new EventEmitter<number>();

    current: SelectSearchData = { id: -1, text: 'Seleziona' };

    inputs = [];
    private allInputs = [];

    showList = false;
    searchValue = '';

    constructor(private _search: SearchService) { }

    initValue() {
        // console.log('inizializzazione con id ' + this.current.id);
        const curr = this.inputs.filter(x => x.id === this.current.id)[0];
        if (curr) {
            this.current.text = curr.text;
        }
    }

    doSearch() {
        this.inputs = this.allInputs;
        this.inputs = this._search.searchFilter(this.inputs, this.searchValue, ['text']);
    }

    dropdownclicked() {
        this.showList = !this.showList;
    }

    selectElement(el) {
        this.selModel = el.id;
        this.selModelChange.emit(this.selModel);
        this.current.text = el.text;
        this.current.id = el.id;
        this.searchValue = '';
        this.doSearch();
        this.dropdownclicked();
    }

    doCancel() {
        this.selModel = -1;
        this.selModelChange.emit(this.selModel);
        this.current.text = 'Seleziona';
        this.current.id = -1;
        this.searchValue = '';
        this.dropdownclicked();
    }
}
